
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.042 1.667v4.427c0 .43.351.78.78.78h4.428v10.678a.78.78 0 01-.781.781H4.53a.78.78 0 01-.781-.781V2.448a.78.78 0 01.781-.781h6.51zm5.208 4.166v-.198a.779.779 0 00-.228-.55l-3.187-3.19a.78.78 0 00-.553-.228h-.199v4.166h4.167zm-9.792 2.24a.625.625 0 100 1.25h7.084a.625.625 0 000-1.25H6.458zm-.625 3.394c0-.345.28-.625.625-.625h4.666a.625.625 0 010 1.25H6.458a.625.625 0 01-.625-.625zm.625 2.145a.625.625 0 100 1.25h2.584a.625.625 0 100-1.25H6.458z","fill":"#fff"}})])
          )
        }
      }
    